import { render, staticRenderFns } from "./AssetSidebar.vue?vue&type=template&id=5a2db370&scoped=true"
import script from "./AssetSidebar.vue?vue&type=script&lang=js"
export * from "./AssetSidebar.vue?vue&type=script&lang=js"
import style0 from "./AssetSidebar.vue?vue&type=style&index=0&id=5a2db370&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a2db370",
  null
  
)

export default component.exports